<template>
  <div>
    <!-- 头部 -->
    <back :title="titlename"></back>
    <ul class="doorlist">
      <div v-for="(item,i) in list">
        <li :class="[item.STATUS==0||item.STATUS==2||item.STATUS==3||item.STATUS==5?'status1':'',item.STATUS==4?'status2':'',item.STATUS==1?'status3':'']">
          <p>{{status(item.STATUS)}}</p>
          <p>业务类型：<span>{{item.YEWUNAME}}</span></p>
          <p>事项名称：<span>{{item.SHIXIANGNAME}}</span></p>
          <p>办理网点：<span>{{item.WDNAME}}</span></p>
          <p>上门时间：<span>{{item.YYTIME}}</span></p>
          <ul class="progress" v-if="list[i].auditList.length!=0">
            <li v-for="items in list[i].auditList">
              <p>{{items.AUDITNAME}}</p>
              <span></span>
              <p>{{datetimeFormatday(items.RECORDTIME)}}</p>
              <i></i>
            </li>
          </ul>
          <div v-if="item.STATUS==0">
            <button @click="qx(item.YYBID)">取消办理</button>
          </div>
          <div v-if="item.STATUS==1">
            <button @click="link(item.YYBID)">再次提交</button>
          </div>
          <div v-if="item.STATUS==2||item.STATUS==3">
            <button v-if="item.PINGJIA==1||item.PINGJIA==2||item.PINGJIA==3||item.PINGJIA==4||item.PINGJIA==5">已评价</button>
            <button v-else @click="show(item.YYBID)">评价</button>
          </div>
        </li>
        <div class="line"></div>
      </div>


      <!-- <li class="status2">
        <p>待办理</p>
        <p>业务类型：<span>1</span></p>
        <p>办理网点：<span></span></p>
        <p>上门时间：<span></span></p>
        <div>
          <button>再次提交</button>
        </div>
      </li>
      <div class="line"></div>
      <li class="status3">
        <p>审核中</p>
        <p>业务类型：<span>1</span></p>
        <p>办理网点：<span></span></p>
        <p>上门时间：<span></span></p>
        <div>
          <button>取消办理</button>
        </div>

      </li> -->
    </ul>
    <!-- 弹窗评价 -->
    <div class="pf-bg" v-show="pfshow">
    	<div class="pingfen">
    		<div class="header">
    			服务评价
    		</div>
    		<div class="content">
    			<div class="stars">
    				<span @click="star(1)"></span>
    				<span @click="star(2)"></span>
    				<span @click="star(3)"></span>
    				<span @click="star(4)"></span>
    				<span @click="star(5)"></span>
    			</div>
    			<!-- <div class="info">5星</div> -->
    		</div>
    		<div class="tips">
          <button @click="qxs">取消</button>
          <button @click="pj">评价</button>
        </div>

    	</div>
    </div>
  </div>
</template>

<script>
    import { Toast } from 'vant'
  export default {
      data() {
        return {
           titlename:"元和街道第一窗口",
           list:[],
           pfshow:false,
           pjcontent:"评价",
           index:"",
           yybID:""
        };
      },
      created:function(){
        this.getlist()
      },
      methods:{
        getlist(){
          this.$http.post(this.$store.state.host + "/interface/myYybList", {OPENID:this.$store.state.openId,}, {
              emulateJSON: true
            })
            .then(res => {
              //发送成功
              console.log(res)
              if (res.body.code == 0) {
                this.list=res.body.list
                console.log(this.list[0].auditList)
              }
              else{

              }

              //if()
            }, res => {
              //发送失败
            })
        },
        // 判断状态
        status(obj){
          if(obj==0){
            return "待办理"
          }
          if(obj==1){
            return "中止办理"
          }
          if(obj==2){
            return "办理成功"
          }
          if(obj==3){
            return "终止办理"
          }
          if(obj==4){
            return "已取消"
          }
          if(obj==5){
            return "办理中"
          }
        },
        // 取消
        qx(obj){
          Toast.loading({
            message: '取消中...',
            forbidClick: true,
            duration:0
          });
          this.$http.post(this.$store.state.host + "/interface/yybCancel", {YYBID:obj}, {
              emulateJSON: true
            })
            .then(res => {
              //发送成功
              console.log(res)
              if (res.body.code == 0) {
                Toast.success('取消成功');
                this.getlist()
                //this.list=res.body.list
              }
              else{
                Toast.success(res.body.msg);
                this.getlist()
              }

              //if()
            }, res => {
              //发送失败
            })
        },
        link(obj){
          this.$router.push({path:'/Appointmentinfo',query:{yybid:obj}})
        },
        // 评价弹窗显示
        show(obj){
          this.pfshow=true
          this.yybID=obj
        },
        pj(){
          if(this.index==0){
            Toast("请选择评价分数")
            return false
          }
          console.log(this.yybID)
          this.$http.post(this.$store.state.host + "/interface/yybPingjia", {YYBID:this.yybID,PINGJIA:this.index}, {
              emulateJSON: true
            })
            .then(res => {
              //发送成功
              console.log(res)
              if (res.body.code == 0) {
                this.pfshow=false
                this.pjcontent="已评价"
                Toast.success('评价成功');
                this.getlist()
                this.qxs()
                //this.list=res.body.list
              }
              else{
                Toast.success(res.body.msg);
                this.getlist()
              }

              //if()
            }, res => {
              //发送失败
            })

        },
        // 评价星星点击
        star(obj){
          let stars=document.querySelectorAll('.stars span')
          this.index=obj
          for(var i=0;i<stars.length;i++){
            stars[i].className= "";
          }
          for(var i=0;i<obj;i++){
            stars[i].className= "show";
          }

        },
        //评价取消
        qxs(){
          this.pfshow=false
          let stars=document.querySelectorAll('.stars span')
          for(var i=0;i<stars.length;i++){
            stars[i].className= "";
          }
        },
        datetimeFormatday: function(time) {
          // let str=time
          // let date=time
          // str=str.substring(0,4)
          // date=date.substring(11,16)
          // str=str+' '+date
          // return str
        	if (time == null || time == "" || time == undefined) {
        		return;
        	}
        	var date = new Date(time);
        	/* 在日期格式中，月份是从0开始的，因此要加0
        	 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
        	 * */
        	var year = date.getFullYear();
        	var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        	var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        	let hours = date.getHours() < 10 ? "0" + date.getHours() : date
        .getHours(); // getHours() 返回小时 (0 ~ 23)
        	let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date
        .getMinutes(); // getMinutes() 返回分(0 ~ 59)
        	// 拼接
        	return month+'.'+day + " " + hours + ":" + minutes;
        },
      },
      mounted:function(){


      }
    };
</script>

<style lang="less" scoped>
  div.line{
    background: #f6f6f6;
    width: 100%;
    height: .1rem;
  }
  .doorlist{
    font-size: .3rem;
    padding: 0rem 0rem;
    color: #666666;
    li{
      padding: .2rem .4rem;
      p{
        margin-bottom: .2rem;
        span{
          color: #333;
        }
      }
    }
    li.status1{
      p:nth-of-type(1){
        color: #f28033;
      }
      p:nth-of-type(1):before{
        content: "";
        width: .08rem;
        height: .34rem;
        background: #f28033;
        display: inline-block;
        margin-right: .2rem;
        position: relative;
        top: .05rem;
      }
      div{
        text-align: right;
        border-top: .01rem solid #f6f6f6;
        padding-top: .2rem;
        button{
          border: .01rem solid  #f28033;
          background: white;
          color: #f28033;
          border-radius: .05rem;
          padding: .1rem .2rem;
          //font-weight: bold;
        }
      }

    }
    li.status2{
      p:nth-of-type(1){
        color: #3349f2;
      }
      p:nth-of-type(1):before{
        content: "";
        width: .08rem;
        height: .34rem;
        background: #3349f2;
        display: inline-block;
        margin-right: .2rem;
        position: relative;
        top: .05rem;
      }
      div{
        text-align: right;
        border-top: .01rem solid #f6f6f6;
        padding-top: .2rem;
        button{
          border: .01rem solid  #3349f2;
          background: white;
          color: #3349f2;
          border-radius: .05rem;
          padding: .1rem .2rem;
          // font-weight: bold;
        }
      }
    }
    li.status3{
      p:nth-of-type(1){
        color: #f23333;
      }
      p:nth-of-type(1):before{
        content: "";
        width: .08rem;
        height: .34rem;
        background: #f23333;
        display: inline-block;
        margin-right: .2rem;
        position: relative;
        top: .05rem;
      }
      div{
        text-align: right;
        border-top: .01rem solid #f6f6f6;
        padding-top: .2rem;
        button{
          border: .01rem solid  #f23333;
          background: white;
          color: #f23333;
          border-radius: .05rem;
          padding: .1rem .2rem;
          //font-weight: bold;
        }
      }
    }

  }
  .progress{
    background: #fbfbfb;
    padding: .3rem 0rem;
    display: flex;
    position: relative;
    overflow-y: scroll;
    li{
      padding: 0px;
      width: 25%;
      text-align: center;
      font-size: .26rem;
      padding: 0rem .2rem;
      position: relative;
      p{
        margin: 0px;
        color: #333 !important;
        min-width: 1.67rem;
      }
      span{
        width: 8px;
        height: 8px;
        display: block;
        margin: 0.2rem auto;
        background: #666666;
        border-radius: 50%;
        position: relative;
        z-index: 2;
      }
      p:before{
        display: none !important;
      }
      p:nth-of-type(2){
        color:#999999 !important;
        font-size:.26rem
      }
    }
    li:last-child{
      p{
        color: #f28033 !important;
      }
      span{
        background:#f28033 !important;
      }
    }
  }
  .progress i{
    content: "";
    width: 100%;
    height: 1px;
    border-top: 1px solid #e0dede;
    position: absolute;
    top: 50%;
    left: 0px;

  }
  .pf-bg{background-color: rgba(0,0,0,0.5);width: 100%;height: 100vh;position: fixed;top: 0px;left: 0px;z-index: 3;}
  		.pingfen{
  			width: 90%;
  			background: #fff;
  			margin: 0px auto;
  			border-radius: 5px;
  			position: fixed;
        overflow: hidden;
  			top:50%;
  			left: 50%;
  			transform: translate(-50%,-50%);

  		}
  		.header{
  			width: 100%;
  			height: 70px;
  			border-bottom: 1px solid #ef6d31;
  			font-size: 18px;
  			color: #ef6d31;
  			font-weight: bolder;
  			text-align: center;
  			line-height: 72px;


  		}
  		.content{
  			width: 100%;
  			height: 72px;
  		}
  		.stars{
  			width: 100%;
  			list-style: none;
  			margin: 0 auto;
  			line-height: 67px;
  			color: #ccc;
        text-align: center;
  			//margin-left: 30px;
  			// float: left;
  		}
  		.stars span{
  			font-size: 30px;
  			margin-left: 10px;
  		}
  		.stars span:after{
  			content: '☆';
  		}
  		.stars .show:after,.stars .show2:after{
  			content: '★';
  		}
  		.info{
  			float: left;
  			width: 60px;
  			height: 30px;
  			background: #ef6d31;
  			border-radius: 5px;
  			color: #fff;
  			margin-top: 21px;
  			text-align: center;
  			line-height: 30px;
  			display: none;
  		}
  		.tips{
  			width: 100%;
  			padding: .2rem 0px;
  			color: #fff;
  			text-align: center;
        font-size: .3rem;
        button{
          width: 45%;
          border-radius: 5px;
          padding: .1rem 0px;
        }
        button:nth-of-type(1){
          background: #ef6d31;
          border: 1px solid #ef6d31;
          color: white;
        }
        button:nth-of-type(2){
          background: white;
          border: 1px solid #ef6d31;
          color: #ef6d31;
        }
  		}
  		.show {
  				color: #ef6d31;
  			}
  		.show2{
  			color: #ef6d31;
  		}
</style>



// WEBPACK FOOTER //
// src/pages/appointmentlist.vue